"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GroupSpacer = exports.SPACER_WIDTH = void 0;
var React = require("react");
exports.SPACER_WIDTH = 36;
var GroupSpacer = function (props) {
    var count = props.count, _a = props.indentWidth, indentWidth = _a === void 0 ? exports.SPACER_WIDTH : _a, _b = props.role, role = _b === void 0 ? 'presentation' : _b;
    var width = count * indentWidth;
    return count > 0 ? (React.createElement("span", { className: 'ms-GroupSpacer', style: { display: 'inline-block', width: width }, role: role })) : null;
};
exports.GroupSpacer = GroupSpacer;
//# sourceMappingURL=GroupSpacer.js.map